// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://strapi.kreatif.it/api',
  // apiUrl: 'http://localhost:80/api',
  apiUrl: 'https://boymont-api-production.up.railway.app/api',
  mapbox: {
    // TODO change access token
    accessToken:
      'pk.eyJ1Ijoiam9oYW5uZXMta3JlYXRpZiIsImEiOiJja2d0aXhidngwY2I0MnFwMDNueWtib2RkIn0.UpQXbTc3A2e25WD0NoXXsQ',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
